import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { Label } from "@progress/kendo-react-labels";
import { Link } from "react-router-dom";

export const ImageViewField = (fieldRenderProps: FieldRenderProps) => {
  return (
    <FieldWrapper>
      <Label className="k-form-label">Itinerary Image</Label>
      <div className="Image-view-Field">
        {fieldRenderProps?.value && (
          <Link to={fieldRenderProps?.value} target="_Blanck">
            <img
              className="k-form-field-wrap"
              src={fieldRenderProps?.value}
              alt="Itinerary Image"
            />
          </Link>
        )}
      </div>
    </FieldWrapper>
  );
};
